import React, { useEffect } from "react";
import { useStripe, useElements } from '@stripe/react-stripe-js';

const CheckoutForm = (props) => {
    const token = props.props.token;
    const alert = props.props.alert;
    const decodedString = atob(decodeURIComponent(token));
    const searchParams = new URLSearchParams(decodedString);
    const secureID = searchParams.get("secureID");
    const returnUrl = searchParams.get("u");
    const stripe = useStripe();
    const elements = useElements();

    useEffect(() => {
        if (!stripe || !elements) {
            return;
        }

        stripe.confirmCardPayment(secureID, {
            return_url: returnUrl
        })
            .then(function () {
                window.location.href = returnUrl;
            });
    }, [stripe, elements, secureID, returnUrl, alert]);

    return <div></div>;
};

export default CheckoutForm;